import React, {useState} from 'react';
import { withStyles } from "@mui/styles";
import {Dialog, DialogContent, DialogTitle, IconButton, Switch, Typography, useMediaQuery} from '@mui/material';
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import {Close} from "@mui/icons-material";
import {Styles} from "../../../../../config/design/styles";
import Button from "@mui/material/Button";
import {currencySymbol, getMediaURL, price, showExactDate, truncate} from "../../../../../config/values";
import {
    BriefcaseBusiness,
    ChevronRight,
    Gift,
    HandPlatter,
    PanelTopOpen,
    ShoppingCart,
    View,
    Wallet
} from "lucide-react";
import Grid from "@mui/material/Grid2";
import LoadingButton from "../../../../components/elements/LoadingButton";
import {useLocation, useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";

function PurchaseForCharityButton({item,classes,isAuth,user }) {
    const { t } = useTranslation();
    const [open,setOpen] = useState(false);
    const [disabled,setDisabled] = useState(!item.user?.address);
    const [submitLoading, setSubmitLoading] = useState(false);
    const navigation = useNavigate();
    const location = useLocation();
    const [consumeCharge, setConsumeCharge] = useState(false);
    const isPanelIconVisible = useMediaQuery('(min-width:600px) and (max-width:700px)');

    const handleRequest = async (where) => {
        setSubmitLoading(true);

        await localStorage.setItem("charity_name", item.name);
        await localStorage.setItem("charity_slug", item.slug);
        await window.location.replace(where);

        setSubmitLoading(false);
    }
    const handleLogin = () => {
        localStorage.setItem("redirect", location.pathname);
        navigation('/login');
    }

    return (
        <>
            <Button
                onClick={() => setOpen(true)}
                startIcon={!isPanelIconVisible ? <Gift className="lucide-sm"/> : null}
                color="secondary"
                variant="outlined"
                disabled={disabled}
                style={{fontSize:12}}
                className="charity-btn-md"

            >
                <span style={{fontSize:13}}>{t('shopForCharity')}</span>
            </Button>
            {
                !!isAuth ?
                    <Dialog  open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
                        <DialogTitle className="dialog-title">
                            {t('shopForCharity')}
                            <IconButton
                                onClick={() => setOpen(false)}
                                style={{position:"absolute",right:15,top:15}}
                                size="small"
                            >
                                <Close className="lucide-icon"/>
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2}>
                                <Grid item size={12}>
                                    <Box>
                                        <div className="flex-direction">
                                            <img className="charity-logo" src={getMediaURL(item.file,'small')} alt={item.name} style={{width:70}}/>
                                            <div>
                                                <Typography align="left" className="bold mb-10">
                                                    {item.name}
                                                </Typography>
                                                <div className="flex-direction">
                                                    <BriefcaseBusiness className="lucide-small-narrow"/>
                                                    <span>{item.activity_field}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </Box>

                                    <div className="my-15">
                                        <span className="charity-desc">{item.description}</span>
                                    </div>
                                </Grid>
                                <Grid item size={12}>
                                    <div className='donate-holder'>
                                        <Grid container spacing={2}>
                                            <Grid item size={12}>
                                                <div className="text-center flex-direction flex-justify-center">
                                                    <LoadingButton
                                                        className="confirm-btn"
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={() => handleRequest('/restaurants')}
                                                        loading={submitLoading}
                                                    >
                                                        {t("viewRestaurants")}
                                                    </LoadingButton>
                                                    <LoadingButton
                                                        className="confirm-btn"
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={() => handleRequest('/markets')}
                                                        loading={submitLoading}
                                                    >
                                                        {t("viewMarkets")}
                                                    </LoadingButton>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </Dialog>
                    :
                    <Dialog  open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
                        <DialogTitle className="dialog-title">
                            {t('donate')}
                            <IconButton
                                onClick={() => setOpen(false)}
                                style={{position:"absolute",right:15,top:15}}
                                size="small"
                            >
                                <Close className="lucide-icon"/>
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <Typography className="my-20">{t('loginToDoThis')}</Typography>
                            <Button
                                onClick={() => handleLogin()}
                            >
                                {t('login')}
                            </Button>
                        </DialogContent>
                    </Dialog>

            }
        </>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
});

export default withStyles(Styles)(connect(mapStateToProps)(PurchaseForCharityButton));
